import { $, $$, setAttributes, insertHTML } from 'utils/dom';
import Shower, { slideDown, slideUp } from 'modules/shower';
import Bus from 'modules/event-bus';
import FocusTrap from 'modules/focus-trap';

// TODO: Shower should already set default aria-roles on init. If we destroy the shower, remove aria-roles too.
class Navigation {
  BREAKPOINT = 1200;

  constructor(container) {
    this.container = container;
    this.navigation = $('.navigation', this.container);
    this.toggleSecondNavBtn = $$('.toggle-second-level', container);
    this.closeButton = $$('.sublist__close-button', container);
    this.toggleMobileNaviBtn = $('.toggle-nav', container);
    this.secondLevelNaviBtn = $$('.toggle-mobile-second-level', container);
    this.secondNav = $$('.second-level', container);
    this.mobileNavi = $('.navigation', container);
    this.metaNavi = $('.header__meta', container);
    this.windowWidth = 0;
    this.activeDropdown = null;
    this.isAnimating = false;
    this.stateMobileNavi = false;
    this.mobileShower = null;
  }

  resetDesktopNavi = () => {
    this.closeAllDropdowns(1);
  };

  onTopLevelClick = link => {
    const dropdownNode = this.getDropdown(link);

    if (dropdownNode && window.innerWidth > this.BREAKPOINT) {
      const isClosed = dropdownNode.getAttribute('aria-hidden');

      // toggle dropdown via click
      if (isClosed === 'false') {
        this.closeAllDropdowns(350);
      } else {
        this.showDropdown(link, dropdownNode);
      }
    }
  };

  getDropdown = link => {
    const handlerAttribute = link.getAttribute('aria-controls');

    return $(`#${handlerAttribute}`, this.container);
  };

  showDropdown = async (link, dropdown) => {
    if (this.isAnimating) return;
    await this.closeAllDropdowns();

    this.isAnimating = true;
    await slideDown(dropdown, 350);
    this.activeDropdown = dropdown;
    this.isAnimating = false;

    dropdown.setAttribute('aria-hidden', false);
    dropdown.setAttribute('aria-expanded', true);

    setAttributes(link, {
      'aria-expanded': true,
      'aria-selected': true,
    });
  };

  closeAllDropdowns = async duration => {
    if (this.isAnimating || !this.activeDropdown) return;

    this.isAnimating = true;
    await slideUp(this.activeDropdown, duration);
    this.isAnimating = false;
    this.activeDropdown = null;

    this.secondNav.forEach(dropdown => {
      dropdown.setAttribute('aria-hidden', true);
      dropdown.setAttribute('aria-expanded', false);
    });

    this.toggleSecondNavBtn.forEach(link => {
      setAttributes(link, {
        'aria-expanded': false,
        'aria-selected': false,
      });
    });
  };

  initMobileNavi = () => {
    if (
      window.innerWidth <= this.BREAKPOINT &&
      this.stateMobileNavi === false
    ) {
      this.stateMobileNavi = true;

      // reset seocond-level navigation
      this.secondNav.forEach(panel => {
        panel.removeAttribute('style');
        panel.removeAttribute('aria-hidden');
      });

      const target = this.mobileNavi;
      const handler = this.toggleMobileNaviBtn;

      this.mobileShower = new Shower({
        target,
        handler,
        easing: 'easeInOutQuart',
        duration: 350,
        initOpened: false,
        openClassName: 'is-open',
      });
      this.mobileShower.init();

      this.initLowerShower();
    } else if (
      window.innerWidth > this.BREAKPOINT &&
      this.stateMobileNavi === true
    ) {
      this.stateMobileNavi = false;

      this.mobileShower.destroy();

      this.toggleMobileNaviBtn.classList.remove('is-open');
      this.toggleMobileNaviBtn.setAttribute('aria-expanded', 'false');
      this.mobileNavi.removeAttribute('style');
      this.mobileNavi.removeAttribute('aria-hidden');
      this.mobileNavi.classList.remove('is-open');

      $$('.sublist', this.container).forEach(navi =>
        navi.removeAttribute('style')
      );

      this.mobileShower = null;
    }
  };

  initLowerShower = () => {
    const togglers = this.secondLevelNaviBtn.map(handler => {
      const target = handler.nextElementSibling;

      return new Shower({
        target,
        handler,
        easing: 'easeInOutQuart',
        duration: 350,
        initOpened: false,
        openClassName: 'is-open',
      });
    });

    togglers.forEach(toggle => {
      // send in the other Shower instances to close when one opens
      toggle.closeInstances = togglers.filter(t => t !== toggle);
      toggle.init();
    });
  };

  setUpAttributes = () => {
    this.toggleSecondNavBtn.forEach((button, i) => {
      button.setAttribute('aria-controls', `nav-list-${i}`);
      button.setAttribute('id', `nav-${i}`);
    });

    this.secondNav.forEach((navitem, i) => {
      navitem.setAttribute('aria-labelledby', `nav-${i}`);
      navitem.setAttribute('id', `nav-list-${i}`);
    });
  };

  cloneMetaNav = () => {
    const clone = this.metaNavi.cloneNode(true);

    clone.classList.add('mobile-meta');

    // remove event-toggler
    clone.lastElementChild.remove();
    insertHTML(this.navigation.firstElementChild, 'afterend', clone.outerHTML);
  };

  onResize = () => {
    this.windowWidth = window.innerWidth;
    this.resetDesktopNavi();
    this.initMobileNavi();
  };

  bindEvents = () => {
    this.toggleSecondNavBtn.forEach(link => {
      link.addEventListener('click', this.onTopLevelClick.bind(this, link));
    });

    this.closeButton.forEach(button => {
      button.addEventListener('click', () => {
        this.closeAllDropdowns();
      });
    });

    window.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        this.closeAllDropdowns();
      }
    });

    Bus.subscribe('resize', 'Navigation', this.onResize);
  };

  init = () => {
    this.setUpAttributes();
    this.cloneMetaNav();
    this.bindEvents();
    this.initMobileNavi();
  };
}

const fontSizes = [null, '110%', '120%'];
let currentIndex = 0;

setTimeout(() => {
  $$('[data-font-size-adjust]').forEach(btn =>
    btn.addEventListener('click', () => {
      const index = ++currentIndex % fontSizes.length;

      // document.documentElement.style.fontSize = fontSizes[index];
      document.documentElement.setAttribute(
        'style',
        `font-size:${fontSizes[index]};`
      );

      // eslint-disable-next-line no-unused-expressions
      btn.style.setProperty?.(
        '--indicator-offset',
        `${(100 / fontSizes.length) * index}%`
      );
    })
  );
}, 0);

const navigation = $('.header');
const mainNav = $('.navigation');
mainNav && navigation && new Navigation(navigation).init();

const focusHandler = $$('.toggle-second-level');
if (focusHandler.length) {
  focusHandler.forEach((handler, i) => {
    const target = $(`#nav-list-${i}`);
    const closeButton = $('.sublist__close-button', target);
    new FocusTrap(handler, target, closeButton).init();
  });
}
